// Cars data with artists and image paths
const artCars = {
    "#1": { 
      number: 1, 
      artist: "Alexander Calder", 
      year: 1975, 
      model: "BMW 3.0 CSL",
      image: "/images/bmw-art-car-1-calder.jpg" 
    },
    "#2": { 
      number: 2, 
      artist: "Frank Stella", 
      year: 1976, 
      model: "BMW 3.0 CSL",
      image: "/images/bmw-art-car-2-stella.jpg" 
    },
    "#3": { 
      number: 3, 
      artist: "Roy Lichtenstein", 
      year: 1977, 
      model: "BMW 320i",
      image: "/images/bmw-art-car-3-lichtenstein.jpg" 
    },
    "#4": { 
      number: 4, 
      artist: "Andy Warhol", 
      year: 1979, 
      model: "BMW M1",
      image: "/images/bmw-art-car-4-warhol.jpg" 
    },
    "#5": { 
      number: 5, 
      artist: "Ernst Fuchs", 
      year: 1982, 
      model: "BMW 635 CSi",
      image: "/images/bmw-art-car-5-fuchs.jpg" 
    },
    "#6": { 
      number: 6, 
      artist: "Robert Rauschenberg", 
      year: 1986, 
      model: "BMW 635 CSi",
      image: "/images/bmw-art-car-6-rauschenberg.jpg" 
    },
    "#7": { 
      number: 7, 
      artist: "Michael Jagamara Nelson", 
      year: 1989, 
      model: "BMW M3",
      image: "/images/bmw-art-car-7-nelson.jpg" 
    },
    "#8": { 
      number: 8, 
      artist: "Ken Done", 
      year: 1989, 
      model: "BMW M3",
      image: "/images/bmw-art-car-8-done.jpg" 
    },
    "#9": { 
      number: 9, 
      artist: "Matazo Kayama", 
      year: 1990, 
      model: "BMW 535i",
      image: "/images/bmw-art-car-9-kayama.jpg" 
    },
    "#10": { 
      number: 10, 
      artist: "César Manrique", 
      year: 1990, 
      model: "BMW 730i",
      image: "/images/bmw-art-car-10-manrique.jpg" 
    },
    "#11": { 
      number: 11, 
      artist: "A.R. Penck", 
      year: 1991, 
      model: "BMW Z1",
      image: "/images/bmw-art-car-11-penck.jpg" 
    },
    "#12": { 
      number: 12, 
      artist: "Esther Mahlangu", 
      year: 1991, 
      model: "BMW 525i",
      image: "/images/bmw-art-car-12-mahlangu.jpg" 
    },
    "#13": { 
      number: 13, 
      artist: "Sandro Chia", 
      year: 1992, 
      model: "BMW M3 GTR",
      image: "/images/bmw-art-car-13-chia.jpg" 
    },
    "#14": { 
      number: 14, 
      artist: "David Hockney", 
      year: 1995, 
      model: "BMW 850 CSi",
      image: "/images/bmw-art-car-14-hockney.jpg" 
    },
    "#15": { 
      number: 15, 
      artist: "Jenny Holzer", 
      year: 1999, 
      model: "BMW V12 LMR",
      image: "/images/bmw-art-car-15-holzer.jpg" 
    },
    "#16": { 
      number: 16, 
      artist: "Olafur Eliasson", 
      year: 2007, 
      model: "BMW H2R",
      image: "/images/bmw-art-car-16-eliasson.jpg" 
    },
    "#17": { 
      number: 17, 
      artist: "Jeff Koons", 
      year: 2010, 
      model: "BMW M3 GT2",
      image: "/images/bmw-art-car-17-koons.jpg" 
    },
    "#18": { 
      number: 18, 
      artist: "John Baldessari", 
      year: 2016, 
      model: "BMW M6 GTLM",
      image: "/images/bmw-art-car-18-baldessari.jpg" 
    },
    "#19": { 
      number: 19, 
      artist: "Cao Fei", 
      year: 2017, 
      model: "BMW M6 GT3",
      image: "/images/bmw-art-car-19-fei.jpg" 
    },
    "#20": { 
      number: 20, 
      artist: "Julie Mehretu", 
      year: 2023, 
      model: "BMW M Hybrid V8",
      image: "/images/bmw-art-car-20-mehretu.jpg" 
    },
  };
  
  export { artCars };